export enum ClientScanKey {
  AGREEMENT = 'rodoFile',
  AGREEMENT_FINAMAX = 'rodoFinamax',
  OFI = 'ofiFile',
  OFI_FINAMAX = 'ofiFinamax',
}
